// src/App.tsx
import React from "react";
import TaskManagerDashboard from "./components/TaskManagerDashboard";

const App: React.FC = () => {
  return (
    <div>
      <TaskManagerDashboard />
    </div>
  );
};

export default App;
